import { Component, OnInit } from '@angular/core';
import { UrlService } from '../../services/url.service';
import { AlertService } from '../../services/alert.service';
import { UrlInfo } from '../../models/url.info.model';

@Component({
  selector: 'app-saikitubeedit',
  templateUrl: './saiki-tube-edit.component.html',
  styleUrls: ['./saiki-tube-edit.component.css']
})
export class SaikiTubeEditComponent implements OnInit {

  urlInfo: UrlInfo;
  isUpdating = false;

  constructor(private urlService: UrlService, private alertService: AlertService) { }

  ngOnInit() {
    this.urlService.getSaikiTubeUrl().subscribe(response => this.urlInfo = response);
  }

  clearMessage() {
    this.alertService.resetStickyMessage();
  }

  update() {
    this.clearMessage();
    this.isUpdating = true;

    this.urlService.updateSaikiTubeUrl(this.urlInfo.url).subscribe(() => {
      setTimeout(() => {
        this.isUpdating = false;
      }, 500);
    });
  }
}
